import { surveyLocalization } from "survey-core";

/**
 * Overrides the SurveyJS "required" validation message with the copy shared
 * across every quiz variant. Idempotent — safe to call at module scope in each
 * quiz entry point.
 */
export const setQuizLocalization = () => {
    surveyLocalization.locales["en"] = {
        ...surveyLocalization.locales["en"],
        requiredError:
            "Please respond to ensure we can provide you with the best care.",
    };
};
